module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "scrollload",
    class: {
      'hide': _vm.hide, 'err': _vm.error, 'end': _vm.end
    },
    on: {
      "click": _vm.onScrollload
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-207f9104"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scrollload/scrollload.vue
// module id = 232
// module chunks = 28